let ctx = null;

export const audioCtx = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const noiseBurst = (c, t, { freq = 2500, gain = 0.3, dur = 0.12 } = {}) => {
  const len = Math.floor(c.sampleRate * dur);
  const buf = c.createBuffer(1, len, c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / len);
  const src = c.createBufferSource();
  src.buffer = buf;
  const bp = c.createBiquadFilter();
  bp.type = "bandpass";
  bp.frequency.value = freq;
  const g = c.createGain();
  g.gain.value = gain;
  src.connect(bp).connect(g).connect(c.destination);
  src.start(t);
};

export function playYelp() {
  const c = audioCtx();
  const t = c.currentTime;
  const o = c.createOscillator();
  o.type = "square";
  o.frequency.setValueAtTime(650 + Math.random() * 250, t);
  o.frequency.exponentialRampToValueAtTime(130, t + 0.18);
  const g = c.createGain();
  g.gain.setValueAtTime(0.16, t);
  g.gain.exponentialRampToValueAtTime(0.001, t + 0.2);
  o.connect(g).connect(c.destination);
  o.start(t);
  o.stop(t + 0.22);
  noiseBurst(c, t, { freq: 1800, gain: 0.12 });
}

export function playGuitar() {
  const c = audioCtx();
  const t = c.currentTime;
  const shaper = c.createWaveShaper();
  const curve = new Float32Array(256);
  for (let i = 0; i < 256; i++) curve[i] = Math.tanh(4 * (i / 128 - 1));
  shaper.curve = curve;
  const g = c.createGain();
  g.gain.setValueAtTime(0.22, t);
  g.gain.exponentialRampToValueAtTime(0.001, t + 0.9);
  shaper.connect(g).connect(c.destination);
  [82.41, 123.47, 164.81].forEach((f, i) => {
    const o = c.createOscillator();
    o.type = "sawtooth";
    o.frequency.value = f * (1 + i * 0.0012);
    o.connect(shaper);
    o.start(t + i * 0.035);
    o.stop(t + 0.95);
  });
  noiseBurst(c, t, { freq: 900, gain: 0.08, dur: 0.2 });
}

export function playThwack() {
  const c = audioCtx();
  const t = c.currentTime;
  const o = c.createOscillator();
  o.frequency.setValueAtTime(150, t);
  o.frequency.exponentialRampToValueAtTime(45, t + 0.12);
  const g = c.createGain();
  g.gain.setValueAtTime(0.5, t);
  g.gain.exponentialRampToValueAtTime(0.001, t + 0.2);
  o.connect(g).connect(c.destination);
  o.start(t);
  o.stop(t + 0.22);
  noiseBurst(c, t, { freq: 3200, gain: 0.25, dur: 0.08 });
}

export const SOUND_MAP = { yelp: playYelp, guitar: playGuitar, thwack: playThwack };
